export const varId = (model) => (index) => `${model}_var_${index}`;

export const indirectVarId = (varIdFn, model) => (index) => `${model}_${varIdFn(index)}`;
